module.exports = __webpack_public_path__ + "img/logo_h.e9db1f45.png";